import React, { SyntheticEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import { useLocation } from 'react-router-dom';
import UnathorizedLayout from '../../shared/layout/UnauthorizedLayout';
import { AlertContext } from '../../shared/app/AlertProvider';
import { IError } from '../../../types';
import { useStyles } from './styles';

const AccountVerification = () => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext);

  const resendEmail = async (e: SyntheticEvent) => {
    Auth.resendSignUp(location.state.username)
      .then(() => {
        showAlert({
          severity: 'success',
          message: t(
            'v2.verification.snackbar_label_verificationEmailSentAgain',
          ),
        });
      })
      .catch((err: IError) => {
        showAlert({
          severity: 'error',
          message: t('v2.global.snackbar_label_error_somethingWentWrong'),
        });
      });
  };

  return (
    <UnathorizedLayout
      title={t('v2.verificationLinkExpired.header_label_title')}
      subtitle={t('v2.verificationLinkExpired.header_label_subTitle')}
    >
      <Box className={classes.content}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1">
              {t('v2.verificationLinkExpired.label_expiredVerificationLink')}
              <MuiLink
                component="a"
                href="#"
                onClick={resendEmail}
                className={classes.links}
              >
                {t('v2.verificationLinkExpired.button_expiredVerificationLink')}
              </MuiLink>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              {t('v2.global.label_needHelp')}
              <MuiLink
                component="a"
                className={classes.links}
                href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
              >
                {t('v2.global.button_needHelp')}
              </MuiLink>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </UnathorizedLayout>
  );
};

export default AccountVerification;
